<div class="data-table-toolbar">
  <div class="data-table-toolbar__items" [hidden]="tableIsLoading">
    <div class="data-table-toolbar__clear-selected-container" *ngIf="selectedRows?.length > 0">
      <button class="data-table-toolbar__clear-selected-btn" (click)="clearSelected()"></button>
      <span class="data-table-toolbar__clear-selected-message"><strong>{{selectedRows.length}}</strong> selected</span>
    </div>
    <bssh-column-switcher
      *ngIf="
        gridOptions.columnDefs &&
        gridOptions.columnDefs.length > 0 &&
        showColumnsSwitcher === 'enable'
      "
      [columnDefs]="gridOptions.columnDefs"
      (onChange)="setColumns($event)"
      [title]="columnSwitcherTitle"
      [selectAllTitle]="columnSwitcherSelectAllTitle"
    ></bssh-column-switcher>
    <lib-custom-page-size-controller
        #pageSizeController
        [hidden]="showPageSizeController != 'enable'"
        [showPageSizeChangeController]="showPageSizeChangeController"
        (onChange)="onPageSizeChanged($event)"
        [isSearchApiData]="isSearchApiData"
      >
    </lib-custom-page-size-controller>
  </div>
</div>

<ag-grid-angular
  *ngIf="!serverSide"
  class="data-table"
  [gridOptions]="gridOptions"
  [rowData]="rowData"
  [icons]="icons"
  [frameworkComponents]="frameworkComponents"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged($event)"
  (sortChanged)="onSortChanged($event)"
  (filterChanged)="onFilterChanged($event)"
  (filterModified)="onFilterModified($event)"
  (rowDataChanged)="onRowDataChanged($event)"
  (rowDataUpdated)="onRowDataUpdated($event)"
  (paginationChanged)="onPaginationChanged()"
  [postProcessPopup]="postProcessPopup"
  [defaultColDef]="defaultColDef"
  (columnResized)="onColumnResize($event)"
>
</ag-grid-angular>

<ag-grid-angular
  *ngIf="serverSide"
  class="data-table"
  [gridOptions]="gridOptions"
  [icons]="icons"
  [frameworkComponents]="frameworkComponents"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="debouncedSelectionChanged($event)"
  (sortChanged)="onSortChanged($event)"
  (filterChanged)="onFilterChanged($event)"
  (filterModified)="onFilterModified($event)"
  (rowDataChanged)="onRowDataChanged($event)"
  (rowDataUpdated)="onRowDataUpdated($event)"
  (displayedColumnsChanged)="onDisplayedColumnsChanged($event)"
  [postProcessPopup]="postProcessPopup"
  [defaultColDef]="defaultColDef"
  (columnResized)="onColumnResize($event)"
>
</ag-grid-angular>

<lib-pagination
  #libPagination
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  (pageChanged)="onPageChanged($event)"
  [class.ag-hidden]="!gridOptions.pagination"
>
</lib-pagination>
